import { NgModule, Component, Input, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common'
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'series-list',
    templateUrl: 'series-list.template.html',
    styleUrls: ['series-list.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeriesList {
    @Input() item: any;
    private subs: any;

    /**
     * SeriesList component
     */
    constructor(private coreEffects: CoreEffects, private cd: ChangeDetectorRef, ) {
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/series/series-list/series-list.component.ts